export default __webpack_public_path__ + "static/media/fish&chips-bolditalic.7b328b39.woff";